import { Form } from "react-bootstrap";
import styled from "styled-components";

export const SFilterSection = styled.div`
  margin-top: 0.5rem;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  flex: 0;
  gap: 0.5rem;
  padding: 0.25rem 0;
`;

export const SFilterCheck = styled(Form.Check)<{ $checked: boolean; $isPrimary?: boolean }>`
  margin: 0;
  min-height: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  border: 1px solid
    ${({ $checked, $isPrimary }) =>
      $checked
        ? $isPrimary
          ? "rgba(15, 112, 184, 0.95)"
          : "rgba(39, 132, 89, 0.8)"
        : "rgba(145, 161, 176, 0.55)"};
  background: ${({ $checked, $isPrimary }) =>
    $checked
      ? $isPrimary
        ? "rgba(37, 143, 221, 0.18)"
        : "rgba(79, 170, 120, 0.16)"
      : "rgba(255, 255, 255, 0.85)"};
  box-shadow: ${({ $checked }) =>
    $checked ? "0 2px 5px rgba(24, 61, 91, 0.12)" : "0 1px 2px rgba(24, 61, 91, 0.06)"};
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(24, 61, 91, 0.14);
  }

  .form-check-input {
    float: none;
    margin: 0;
    flex-shrink: 0;
    cursor: pointer;
  }

  .form-check-label {
    font-size: small;
    color: ${({ $checked }) => ($checked ? "#17324a" : "#425466")};
    cursor: pointer;
    user-select: none;
    line-height: 1.2;
  }
`;
